import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Modal, TextField, Thumbnail, ResourceItem} from '@shopify/polaris';
// import ImageThumb from '@presentational/ImageThumb';
import QuantityProgress from '@presentational/QuantityProgress';

const propTypes = {
  items: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  primaryAction: PropTypes.func.isRequired,
  secondaryAction: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
};


const TransferShippingModal = (props) => {
  console.log("TransferShippingModal", props);
  return (
    <Modal
      open={props.open}
      size="Full"
      large
      title="Entrega"
      onClose={ props.onClose }

      primaryAction={{
        content: I18n.t("actions.send"),
        onAction: props.primaryAction,
        loading: props.loading,
      }}
      secondaryActions={[
        {
          content: I18n.t("actions.discard"),
          onAction: props.secondaryAction,
          loading: props.loading,
        },
      ]}
    >
      <Modal.Section>
        { props.items.map( (pt, index) => 
          <TransferItem 
            key={ pt.id }
            item={pt}
            handleChange={ (value, name) => props.handleChange(name, value) }
            name={`items.${index}.to_ship`}
          />
        )}
      </Modal.Section>
    </Modal>
  );
}

const TransferItem = ({ item, handleChange, name }) => (
  <ResourceItem id={item.variant.id}>
    <div className="flex justifyBetween">
      <div className="flex alignItemsCenter">
        <div className="mr10">
          <Thumbnail source={ item.variant.image_url } />
        </div>
        <div className="flex flexColumn">
          <p>{item.variant.display_name_x || item.variant.title}</p>
          <p>SKU: {item.variant.sku}</p>
        </div>
      </div>

        <div className="flex">
          <div
            className="mr20" 
            style={{ minWidth: "200px" }}>
            <QuantityProgress
              total={item.quantity}
              quantity={item.shipped + Number(item.to_ship) } />
          </div>
          <TextField
            id={name}
            name={name}
            type="number"
            className="mr5"
            min={0}

            onChange={ handleChange}
            value={item.to_ship} />
        </div>

    </div>
  </ResourceItem>
);


TransferShippingModal.propTypes = propTypes;


export default TransferShippingModal;
